<app-sale-file-upload
	type="dropzone"
	class="justify-self-center self-center w-full h-full"
	[saleId]="matterId"
	[documentType]="TLFileType"
	(success)="onUploadSuccess()"
></app-sale-file-upload>
